module.exports = __webpack_public_path__ + "img/goods4_4.15987c41.jpg";